import React from "react";
import { inject, observer } from 'mobx-react'
import {Component} from "react/lib/ReactBaseClasses";
import ValidacaoStore from "../stores/ValidacaoStore";
import moment from "moment/moment";
import {FormGroup} from "reactstrap";
import PropTypes from "prop-types";

@inject("store")
@observer
export class Alerta extends Component {

    static propTypes = {
        id: PropTypes.number,
        alertas: PropTypes.array,
        isBloqueante: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.formStore = this.props.store.formStore;
    }

    componentWillUnmount() {
        this.validacaoStore.resetDados(this.props.id);
    }

    render() {
        if(this.props.isBloqueante) {
            this.validacaoStore.campoValid(this.props.id, this.props.alertas && this.props.alertas.length < 1);
            this.validacaoStore.submitStatus();
        } else {
            this.validacaoStore.campoValid(this.props.id, true);
            this.validacaoStore.submitStatus();
        }

        return (<div>
                {this.props.alertas && this.props.alertas.length > 0 && this.props.alertas.map((alerta, index) => {
                    return <p key={index} style={{color: this.props.isBloqueante ? 'red' : "darkorange", display: 'block', "marginBottom": "2px"}}>{alerta}</p>
                })}
            </div>
        );
    }
}